import { render, staticRenderFns } from "./Developers.vue?vue&type=template&id=0f2def9a&scoped=true&"
import script from "./Developers.vue?vue&type=script&lang=js&"
export * from "./Developers.vue?vue&type=script&lang=js&"
import style0 from "./Developers.vue?vue&type=style&index=0&id=0f2def9a&scoped=true&lang=scss&"
import style1 from "./Developers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2def9a",
  null
  
)

export default component.exports